import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Link } from "react-router-dom";

import "../assets/css/HomePage.css";
import {  s1,  s3, s4 } from "../assets/images";

function getLangPath(path, lang) {
  if (lang === "bn") {
    if (path.startsWith("/bn")) return path;
    return `/bn${path.startsWith("/") ? path : "/" + path}`;
  }
  return path.startsWith("/") ? path : "/" + path;
}

/* ===== SEO helpers (canonical, hreflang, OG/Twitter, JSON-LD) ===== */
function setMetaName(name, content) {
  if (!content) return;
  let el = document.querySelector(`meta[name="${name}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute("name", name);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}
function setMetaProperty(property, content) {
  if (!content) return;
  let el = document.querySelector(`meta[property="${property}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute("property", property);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}
// порядок атрибутов строго: href → hreflang
function upsertLink(rel, href, extra = {}) {
  if (!href) return;
  let selector = `link[rel="${rel}"]`;
  if (extra.hreflang) selector += `[hreflang="${extra.hreflang}"]`;
  let el = document.querySelector(selector);
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", rel);
    el.setAttribute("href", href);
    if (extra.hreflang) el.setAttribute("hreflang", extra.hreflang);
    document.head.appendChild(el);
  } else {
    el.setAttribute("href", href);
    if (extra.hreflang) el.setAttribute("hreflang", extra.hreflang);
  }
}
function stripQueryHash(url) {
  try {
    const u = new URL(url);
    u.search = "";
    u.hash = "";
    return u.toString();
  } catch {
    return url;
  }
}
function toAbsoluteUrl(maybeRelative) {
  if (!maybeRelative) return "";
  if (/^https?:\/\//i.test(maybeRelative)) return maybeRelative;
  return `${window.location.origin}${maybeRelative.startsWith("/") ? "" : "/"}${maybeRelative}`;
}

const Slots = () => {
  const { pathname } = useLocation();
  const lang = pathname.startsWith("/bn") ? "bn" : "en";

  // твоя функция — оставляю для совместимости
  function setMetaTag(name, content) {
    let element = document.querySelector(`meta[name="${name}"]`);
    if (element) {
      element.setAttribute("content", content);
    } else {
      element = document.createElement("meta");
      element.name = name;
      element.content = content;
      document.head.appendChild(element);
    }
  }

useEffect(() => {
  // ===== Страница: Slots (EN → BN перевод уже есть) =====
  const titleEN = " HHBD Slots — Play Top Online Slot Machines BD";
  const descEN =
    "Discover hundreds of online slots at HHBD! From jackpots to classic reels, enjoy free spins, bonuses & real BDT wins. Fast deposits and withdrawals through bKash & Nagad for seamless gaming across Bangladesh.";

  const titleBN = "HHBD স্লট — সেরা অনলাইন স্লট মেশিন BD খেলুন";
  const descBN =
    "HHBD-তে শত শত অনলাইন স্লট আবিষ্কার করুন! জ্যাকপট থেকে শুরু করে ক্লাসিক রিল পর্যন্ত, বিনামূল্যে স্পিন, বোনাস এবং আসল বাংলাদেশি টাকা জয় উপভোগ করুন। বাংলাদেশ জুড়ে নির্বিঘ্নে গেমিংয়ের জন্য বিকাশ এবং নগদের মাধ্যমে দ্রুত জমা এবং উত্তোলন।";

  const keywordsEN =
    "HHBD Slots, jackpot slots BD, free spins Bangladesh, online slot games, fruit reels BD, BDT slot wins, mobile slots Bangladesh";
  const keywordsBN =
    "HHBD স্লট, অনলাইন স্লট, ফ্রি স্পিন, জ্যাকপট গেম বিডি, ফল মেশিন, স্লট বোনাস বাংলাদেশ";

  const isBN = lang === "bn";

  // ===== Требование: ВСЕ обычные тайтлы (document/OG/Twitter) — UPPERCASE =====
  const pageTitle = (isBN ? titleBN : titleEN).toUpperCase(); // ✅
  const pageDesc = isBN ? descBN : descEN;                    // обычный регистр
  const pageKeywords = isBN ? keywordsBN : keywordsEN;        // обычный регистр

  // Базовые <title> и meta
  document.title = pageTitle;                 // ✅ UPPERCASE
  setMetaTag("description", pageDesc);        // обычный регистр
  setMetaTag("keywords", pageKeywords);       // обычный регистр

  // URL-ы
  const origin = window.location.origin;
  const cleanPath = pathname || "/";
  const currentAbsUrl = stripQueryHash(`${origin}${cleanPath}`);

  // hreflang альтернативы (en/bn) и x-default
  const urlEn = `${origin}${cleanPath.replace(/^\/bn/, "") || "/"}`;
  const urlBn = `${origin}${getLangPath(cleanPath.replace(/^\/bn/, ""), "bn")}`;

  upsertLink("canonical", currentAbsUrl);
  upsertLink("alternate", urlEn, { hreflang: "en" });
  upsertLink("alternate", urlBn, { hreflang: "bn" });
  upsertLink("alternate", urlEn, { hreflang: "x-default" });

  // Open Graph (тайтл в UPPERCASE)
  const ogImage = toAbsoluteUrl(s1);
  setMetaProperty("og:type", "website");
  setMetaProperty("og:site_name", "HHBD");
  setMetaProperty("og:url", currentAbsUrl);
  setMetaProperty("og:title", pageTitle);           // ✅ UPPERCASE
  setMetaProperty("og:description", pageDesc);      // обычный регистр
  setMetaProperty("og:image", ogImage);
  setMetaProperty("og:image:alt", isBN ? titleBN : titleEN); // alt — читаемый
  setMetaProperty("og:locale", isBN ? "bn_BD" : "en_US");
  setMetaProperty("og:locale:alternate", isBN ? "en_US" : "bn_BD");

  // Twitter (тайтл в UPPERCASE + twitter:url)
  const twitterSite = "@HHBD_official";     // поменяй при необходимости
  const twitterCreator = "@HHBD_official";  // опционально
  const twitterImageAlt = isBN
    ? "HHBD স্লটে স্পিন করুন এবং জিতুন - বাংলাদেশী খেলোয়াড়দের জন্য তৈরি উজ্জ্বল রিল, জ্যাকপট পুরষ্কার এবং বোনাস স্পিন।"
    : "Spin and win at HHBD Slots – bright reels, jackpot prizes and bonus spins made for Bangladeshi players.";

  setMetaName("twitter:card", "summary_large_image");
  setMetaName("twitter:title", pageTitle);        // ✅ UPPERCASE
  setMetaName("twitter:description", pageDesc);   // обычный регистр
  setMetaName("twitter:image", ogImage);
  setMetaName("twitter:image:alt", twitterImageAlt);
  setMetaName("twitter:url", currentAbsUrl);      // ✅ добавлено
  if (twitterSite) setMetaName("twitter:site", twitterSite);
  if (twitterCreator) setMetaName("twitter:creator", twitterCreator);
  setMetaName("twitter:label1", isBN ? "ফিচারস" : "Features");
  setMetaName("twitter:data1", "Free Spins • Jackpots • Mobile");
  setMetaName("twitter:label2", isBN ? "পেমেন্ট" : "Payments");
  setMetaName("twitter:data2", "bKash • Nagad • Rocket • Crypto");


  
}, [lang, pathname]);


  return (
    <>
      {/* --- ENGLISH VERSION --- */}
      <script
  type="application/ld+json"
  // eslint-disable-next-line react/no-danger
  dangerouslySetInnerHTML={{
    __html: (() => {
      const isBN = pathname.startsWith("/bn");
      const origin =
        typeof window !== "undefined" ? window.location.origin : "https://example.com";
      const currentAbsUrl =
        typeof window !== "undefined"
          ? stripQueryHash(`${origin}${pathname || "/"}`)
          : "https://example.com/slots";

      // Page copy (JSON-LD fields in UPPERCASE per your rule)
      const titleEN = " HHBD Slots — Play Top Online Slot Machines BD";
      const descEN =
        "Discover hundreds of online slots at HHBD! From jackpots to classic reels, enjoy free spins, bonuses & real BDT wins. Fast deposits and withdrawals through bKash & Nagad for seamless gaming across Bangladesh.";

      const titleBN = "HHBD স্লট — সেরা অনলাইন স্লট মেশিন BD খেলুন";
      const descBN =
        "HHBD-তে শত শত অনলাইন স্লট আবিষ্কার করুন! জ্যাকপট থেকে শুরু করে ক্লাসিক রিল পর্যন্ত, বিনামূল্যে স্পিন, বোনাস এবং আসল বাংলাদেশি টাকা জয় উপভোগ করুন। বাংলাদেশ জুড়ে নির্বিঘ্নে গেমিংয়ের জন্য বিকাশ এবং নগদের মাধ্যমে দ্রুত জমা এবং উত্তোলন।";

      const pageTitleCaps = (isBN ? titleBN : titleEN).toUpperCase();
      const pageDescCaps  = (isBN ? descBN  : descEN );
      const inLang = isBN ? "bn" : "en";


      const primaryImage =
        typeof s1 === "string"
          ? (/^https?:\/\//i.test(s1) ? s1 : `${origin}${s1.startsWith("/") ? "" : "/"}${s1}`)
          : `${origin}/favicon-512x512.png`;

      const jsonLd = [
        // WebPage
        {
          "@context": "https://schema.org",
          "@type": "WebPage",
          "url": currentAbsUrl,
          "name": pageTitleCaps,
          "inLanguage": inLang,
          "description": pageDescCaps,
          "isPartOf": { "@type": "WebSite", "name": "HHBD", "url": origin },
          "primaryImageOfPage": primaryImage
        },

        // Organization
{
  "@context": "https://schema.org",
  "@type": "Organization",
  "name": pageTitleCaps,
  "url": origin,
  "description": pageDescCaps,
  "logo": {s1}, 
  "address": {
    "@type": "PostalAddress",
    "addressCountry": {
      "@type": "Country",
      "name": "BD"
    },
  },
  "contactPoint": [
    {
      "@type": "ContactPoint",
      "contactType": "customer support",
      "email": "support@ze77-bd.com",
      "availableLanguage": ["English", "বাংলা"]
    }
  ],

},

        // MobileApplication (NO downloadUrl per request)
        {
          "@context": "https://schema.org",
          "@type": "MobileApplication",
          "name": "HHBD APP",
          "inLanguage": inLang,
          "operatingSystem": "Android",
          "applicationCategory": "GameApplication",
          "url": `${origin}/app`,
          "image": primaryImage,
          "offers": {
            "@type": "Offer",
            "price": "0",
            
          },
          "publisher": {
            "@type": "Organization",
            "name": "HHBD",
            "url": origin
          }
        }
      ];

      return JSON.stringify(jsonLd);
    })()
  }}
/>

      {lang === "en" && (
 <>
    <section className="zHHBD-slotshero">
      <div className="zHHBD-slotshero__bg">
        <div className="zHHBD-slotshero__overlay"></div>
        <div className="zHHBD-slotshero__glow zHHBD-slotshero__glow--1"></div>
        <div className="zHHBD-slotshero__glow zHHBD-slotshero__glow--2"></div>
      </div>

      <div className="zHHBD-slotshero__container">
        <div className="zHHBD-slotshero__content">
          <header className="zHHBD-slotshero__header">
            <h1 className="zHHBD-slotshero__title">
              HHBD Slots – Spin, Win & Enjoy Big Jackpots
            </h1>
            <p className="zHHBD-slotshero__desc">
              Step into the heartbeat of online{" "}
              <Link to="/slots" className="zHHBD-slotshero__link" data-discover="true">slots</Link> at HHBD. We’ve gathered a vast array of premium slot{" "}
              <Link to="/games" className="zHHBD-slotshero__link" data-discover="true">games</Link> for players across Bangladesh — blazing themes, creative mechanics, and towering jackpots all in one place. One smooth spin could be the spark that leads to your next headline-making payoff.
            </p>
          </header>

          <div className="zHHBD-slotshero__ctas">
            <a
              href="https://haruvest.com/W7DZsfpK"
              className="zHHBD-slotshero__btn zHHBD-slotshero__btn--main"
              title="Join HHBD Now"
            >
              Join HHBD Now
            </a>
            <a
              href="https://haruvest.com/W7DZsfpK"
              className="zHHBD-slotshero__btn zHHBD-slotshero__btn--ghost"
              title="Download APK"
            >
              Download APK
            </a>
          </div>
        </div>

        <a
          href="https://haruvest.com/W7DZsfpK"
          title="HHBD Slots – Spin the reels and strike big on today’s must-play titles"
        >
          <img
            src={s1}
            alt="A glamorous player in a shimmering silver dress beside a glowing slot cabinet — the electric thrill of HHBD Slots."
            title="HHBD Slots – Spin the reels and strike big on today’s must-play titles"
          />
        </a>
      </div>
    </section>

    <section className="zHHBD-slotscats">
      <div className="zHHBD-slotscats__bg">
        <div className="zHHBD-slotscats__spark zHHBD-slotscats__spark--left"></div>
        <div className="zHHBD-slotscats__spark zHHBD-slotscats__spark--right"></div>
      </div>

      <div className="zHHBD-slotscats__container">
        <header className="zHHBD-slotscats__header">
          <h2 className="zHHBD-slotscats__title">
            Bangladesh’s Ultimate Slot Playground
          </h2>
        </header>

        <div className="zHHBD-slotscats__grid">
          {/* Card 1 */}
          <div className="zHHBD-slotscats__card">
            <div className="zHHBD-slotscats__card-content">
              <div className="zHHBD-slotscats__card-text">
                Welcome to the flagship home of online{" "}
                <Link to="/slots" className="zHHBD-slotscats__link" data-discover="true">slots</Link> in Bangladesh. At HHBD, our hand-picked slate of slot{" "}
                <Link to="/games" className="zHHBD-slotscats__link" data-discover="true">games</Link> is designed for nonstop excitement and real chances to win. Newcomer or veteran, you’ll enjoy a secure, seamless experience engineered for effortless play from click one.
              </div>
            </div>
          </div>

          {/* Card 2 */}
          <div className="zHHBD-slotscats__card">
            <div className="zHHBD-slotscats__card-content">
              <div className="zHHBD-slotscats__card-text">
                The HHBD{" "}
                <Link to="/slots" className="zHHBD-slotscats__link" data-discover="true">slots</Link> universe keeps expanding. Browse everything from timeless classic{" "}
                <Link to="/slots" className="zHHBD-slotscats__link" data-discover="true">slots</Link> with simple charm to cutting-edge video{" "}
                <Link to="/slots" className="zHHBD-slotscats__link" data-discover="true">slots</Link> packed with cinematic flair and layered bonus play. We partner exclusively with trusted studios to ensure top quality and fair, random outcomes.
              </div>
            </div>
          </div>

          {/* Card 3 */}
          <div className="zHHBD-slotscats__card">
            <div className="zHHBD-slotscats__card-content">
              <div className="zHHBD-slotscats__card-text">
                Getting started is a breeze. Explore the library, choose a{" "}
                <Link to="/games" className="zHHBD-slotscats__link" data-discover="true">game</Link> that grabs you, and hit spin. On desktop or mobile, HHBD{" "}
                <Link to="/slots" className="zHHBD-slotscats__link" data-discover="true">slots</Link> are tuned for smooth, consistent performance everywhere. Join today and uncover a new favorite{" "}
                <Link to="/games" className="zHHBD-slotscats__link" data-discover="true">game</Link> in minutes.
              </div>
            </div>
          </div>
        </div>

        <div className="zHHBD-slotscats__cta">
          <a
            href="https://haruvest.com/W7DZsfpK"
            className="zHHBD-slotscats__btn"
            title="Join HHBD Now"
          >
            Join HHBD Now
          </a>
        </div>
      </div>
    </section>

    <section className="zHHBD-slotshowto">
      <div className="zHHBD-slotshowto__bg">
        <div className="zHHBD-slotshowto__spark zHHBD-slotshowto__spark--left"></div>
        <div className="zHHBD-slotshowto__spark zHHBD-slotshowto__spark--right"></div>
      </div>

      <div className="zHHBD-slotshowto__container">
        <header className="zHHBD-slotshowto__header">
          <h2 className="zHHBD-slotshowto__title">
            Get to Know the Main Types of Online Slots
          </h2>
        </header>

        <div className="zHHBD-slotshowto__content">
          <p className="zHHBD-slotshowto__desc">
            {/* берём текст из main (лид в этой секции отсутствует, поэтому используем ровно карточки ниже) */}
          </p>

          <div className="slots-body">
            <p className="zHHBD-slotshowto__desc">
              <strong>Classic Slots</strong> — Relive the charm of retro fruit machines with curated classic{" "}
              <Link to="/slots" className="zHHBD-slotshowto__link" data-discover="true">slots</Link>. These approachable{" "}
              <Link to="/games" className="zHHBD-slotshowto__link" data-discover="true">games</Link> keep things clean and satisfying — perfect for newcomers or anyone who loves straightforward spins.
            </p>

            <p className="zHHBD-slotshowto__desc">
              <strong>Video Slots</strong> — Dive into bold stories, rich visuals, and dynamic audio with modern video{" "}
              <Link to="/slots" className="zHHBD-slotshowto__link" data-discover="true">slots</Link>. These feature-loaded{" "}
              <Link to="/games" className="zHHBD-slotshowto__link" data-discover="true">games</Link> deliver free spins, wilds, multipliers, and layered bonus rounds for endless variety.
            </p>

            <p className="zHHBD-slotshowto__desc">
              <strong>Progressive Jackpots</strong> — Chase life-changing totals with progressive{" "}
              <Link to="/slots" className="zHHBD-slotshowto__link" data-discover="true">slots</Link>. Each wager feeds a shared prize pool, letting jackpots swell to eye-popping figures before one epic spin takes it down.
            </p>

            <p className="zHHBD-slotshowto__desc">
              <strong>Megaways Slots</strong> — Unlock thousands of win ways with Megaways{" "}
              <Link to="/slots" className="zHHBD-slotshowto__link" data-discover="true">slots</Link>. Reel heights shift each spin, remixing symbol counts and keeping play lively, unpredictable, and infinitely replayable.
            </p>
          </div>
        </div>

        <div className="zHHBD-slotshowto__cta">
          <a
            href="https://haruvest.com/W7DZsfpK"
            className="zHHBD-slotshowto__btn"
            title="Play HHBD Slots"
          >
            Play HHBD Slots
          </a>
        </div>

        <a
          href="https://haruvest.com/W7DZsfpK"
          title="HHBD Slots – Try 777 favorites and win real BDT"
        >
          <img
            src={s3}
            alt="A happy player in neon glow enjoying classic 777 reels — the signature HHBD slots vibe."
            className="zHHBD-slotshowto__img-extra"
            title="HHBD Slots – Try 777 favorites and win real BDT"
          />
        </a>
      </div>
    </section>

    <section className="zHHBD-slotsnew">
      <div className="zHHBD-slotsnew__bg">
        <div className="zHHBD-slotsnew__starburst zHHBD-slotsnew__starburst--1"></div>
        <div className="zHHBD-slotsnew__starburst zHHBD-slotsnew__starburst--2"></div>
        <div className="zHHBD-slotsnew__lights"></div>
      </div>

      <div className="zHHBD-slotsnew__container">
        <div className="zHHBD-slotsnew__inner">
          <div className="zHHBD-slotsnew__left">
            <div className="zHHBD-slotsnew__visual">
              <a
                href="https://haruvest.com/W7DZsfpK"
                title="HHBD Slots – Spin the reels and chase major jackpots"
              >
                <img
                  src={s4}
                  alt="A classic cabinet flaunting glowing 777s and stacks of chips — a snapshot of HHBD slot jackpots."
                  className="zHHBD-slotsnew__img"
                  title="HHBD Slots – Spin the reels and chase major jackpots"
                />
              </a>
              <div className="zHHBD-slotsnew__pulse"></div>
              <div className="zHHBD-slotsnew__badge">
                <i className="fa-solid fa-star"></i> NEW
              </div>
              <div className="zHHBD-slotsnew__jackpot-anim">
                <i className="fa-solid fa-coins"></i>
                <span>Jackpot!</span>
              </div>
            </div>
          </div>

          <div className="zHHBD-slotsnew__right">
            <header className="zHHBD-slotsnew__header">
              <h2 className="zHHBD-slotsnew__title">
                Why Play Online Slots at HHBD?
              </h2>
            </header>

            <div className="zHHBD-slotsnew__cards-grid">
              <div className="zHHBD-slotsnew__card">
                <h3 className="zHHBD-slotsnew__card-title">
                  Choosing the right place for{" "}
                  <Link to="/slots" className="zHHBD-slotsnew__link" data-discover="true">slots</Link> changes everything.
                </h3>
                <p className="zHHBD-slotsnew__card-text">
                  At HHBD, we’ve built a player-first environment anchored in satisfaction, rock-solid security, and verified fairness. That focus makes us a standout destination for slot fans throughout Bangladesh.
                </p>
              </div>

              <div className="zHHBD-slotsnew__card">
                <h3 className="zHHBD-slotsnew__card-title">
                  Security isn’t optional — it’s non-negotiable.
                </h3>
                <p className="zHHBD-slotsnew__card-text">
                  Spin with confidence. Our platform uses advanced encryption to protect every detail, from personal info to payments. We’re licensed, regulated, and aligned with strict standards so your experience stays safe end-to-end.
                </p>
              </div>

              <div className="zHHBD-slotsnew__card">
                <h3 className="zHHBD-slotsnew__card-title">
                  Fairness is built in at HHBD.
                </h3>
                <p className="zHHBD-slotsnew__card-text">
                  All slot{" "}
                  <Link to="/games" className="zHHBD-slotsnew__link" data-discover="true">games</Link> run on certified RNG tech to ensure unbiased results on every spin. We also keep RTP data transparent, so you always know exactly what you’re playing.
                </p>
              </div>
            </div>

            <div className="zHHBD-slotsnew__cta">
              <a
                href="https://haruvest.com/W7DZsfpK"
                className="zHHBD-slotsnew__btn"
                title="Play HHBD Slots"
              >
                Play HHBD Slots
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  </>



      )}

      {/* --- BENGALI VERSION --- */}
      {lang === "bn" && (
  <>
    <section className="zHHBD-slotshero">
      <div className="zHHBD-slotshero__bg">
        <div className="zHHBD-slotshero__overlay"></div>
        <div className="zHHBD-slotshero__glow zHHBD-slotshero__glow--1"></div>
        <div className="zHHBD-slotshero__glow zHHBD-slotshero__glow--2"></div>
      </div>

      <div className="zHHBD-slotshero__container">
        <div className="zHHBD-slotshero__content">
          <header className="zHHBD-slotshero__header">
            <h1 className="zHHBD-slotshero__title">
              HHBD স্লট - স্পিন করুন, জিতুন এবং বড় জ্যাকপট উপভোগ করুন
            </h1>
            <p className="zHHBD-slotshero__desc">
              অনলাইন{" "}
              <Link to={getLangPath("/slots", lang)} className="rr555-aviatorlux__link" data-discover="true">স্লটস</Link>–এর হৃদস্পন্দনে পা রাখুন HHBD–এ। আমরা বাংলাদেশের প্লেয়ারদের জন্য প্রিমিয়াম মানের অজস্র স্লট{" "}
              <Link to={getLangPath("/games", lang)} className="rr555-aviatorlux__link" data-discover="true">গেমস</Link> এক জায়গায় সাজিয়ে দিয়েছি — আগুনঝরা থিম, সৃজনশীল মেকানিক্স, আর আকাশছোঁয়া জ্যাকপট সবই একসাথে। মাত্র এক স্মুথ স্পিনই হতে পারে আপনার পরের হেডলাইন–জয়ের স্ফুলিঙ্গ।
            </p>
          </header>

          <div className="zHHBD-slotshero__ctas">
            <a
              href="https://haruvest.com/W7DZsfpK"
              className="zHHBD-slotshero__btn zHHBD-slotshero__btn--main"
              title="এখনই HHBD–এ যোগ দিন"
            >
              এখনই HHBD–এ যোগ দিন
            </a>
            <a
              href="https://haruvest.com/W7DZsfpK"
              className="zHHBD-slotshero__btn zHHBD-slotshero__btn--ghost"
              title="APK ডাউনলোড করুন"
            >
              APK ডাউনলোড করুন
            </a>
          </div>
        </div>

        <a
          href="https://haruvest.com/W7DZsfpK"
          title="HHBD স্লটস – আজকের অবশ্য–খেলার টাইটেলগুলোতে স্পিন করে বড় শট নিন"
        >
          <img
            src={s1}
            alt="ঝলমলে রূপালি ড্রেসে এক গ্ল্যামারাস প্লেয়ার, পাশে জ্বলজ্বলে স্লট ক্যাবিনেট — HHBD স্লটসের ইলেকট্রিক রোমাঞ্চ।"
            title="HHBD স্লটস – আজকের অবশ্য–খেলার টাইটেলগুলোতে স্পিন করে বড় শট নিন"
          />
        </a>
      </div>
    </section>

    <section className="zHHBD-slotscats">
      <div className="zHHBD-slotscats__bg">
        <div className="zHHBD-slotscats__spark zHHBD-slotscats__spark--left"></div>
        <div className="zHHBD-slotscats__spark zHHBD-slotscats__spark--right"></div>
      </div>

      <div className="zHHBD-slotscats__container">
        <header className="zHHBD-slotscats__header">
          <h2 className="zHHBD-slotscats__title">
            বাংলাদেশের আল্টিমেট স্লট প্লেগ্রাউন্ড
          </h2>
        </header>

        <div className="zHHBD-slotscats__grid">
          {/* কার্ড ১ */}
          <div className="zHHBD-slotscats__card">
            <div className="zHHBD-slotscats__card-content">
              <div className="zHHBD-slotscats__card-text">
                বাংলাদেশের অনলাইন{" "}
                <Link to={getLangPath("/slots", lang)} className="rr555-aviatorlux__link" data-discover="true">স্লটস</Link>–এর ফ্ল্যাগশিপ ঘরে স্বাগতম। HHBD–এ আমাদের হাতে–তোলা স্লট{" "}
                <Link to={getLangPath("/games", lang)} className="rr555-aviatorlux__link" data-discover="true">গেমস</Link> তৈরি করা হয়েছে ননস্টপ উত্তেজনা ও সত্যিকারের জয়ের সম্ভাবনার জন্য। আপনি নতুন হোন কিংবা অভিজ্ঞ, প্রথম ক্লিক থেকেই পাবেন সুরক্ষিত, সিমলেস এবং ঝামেলাহীন খেলার অভিজ্ঞতা।
              </div>
            </div>
          </div>

          {/* কার্ড ২ */}
          <div className="zHHBD-slotscats__card">
            <div className="zHHBD-slotscats__card-content">
              <div className="zHHBD-slotscats__card-text">
                HHBD–এর{" "}
                <Link to={getLangPath("/slots", lang)} className="rr555-aviatorlux__link" data-discover="true">স্লটস</Link> ইউনিভার্স ক্রমেই বড় হচ্ছে। চিরন্তন ক্লাসিক{" "}
                <Link to={getLangPath("/slots", lang)} className="rr555-aviatorlux__link" data-discover="true">স্লটস</Link>–এর সরল আকর্ষণ থেকে শুরু করে আধুনিক ভিডিও{" "}
                <Link to={getLangPath("/slots", lang)} className="rr555-aviatorlux__link" data-discover="true">স্লটস</Link>–এর সিনেমাটিক শৈলী ও স্তরে–স্তরে বোনাস—সবই আছে। আমরা কেবল বিশ্বস্ত স্টুডিওর সাথে কাজ করি, যাতে টপ–কোয়ালিটি ও ফেয়ার, র্যান্ডম রেজাল্ট নিশ্চিত থাকে।
              </div>
            </div>
          </div>

          {/* কার্ড ৩ */}
          <div className="zHHBD-slotscats__card">
            <div className="zHHBD-slotscats__card-content">
              <div className="zHHBD-slotscats__card-text">
                শুরু করা একদমই সহজ। লাইব্রেরি ঘুরে দেখুন, যেকোনো{" "}
                <Link to={getLangPath("/games", lang)} className="rr555-aviatorlux__link" data-discover="true">গেম</Link> পছন্দ করুন, তারপর স্পিন। ডেস্কটপ বা মোবাইল—যেখানেই খেলুন না কেন, HHBD–এর{" "}
                <Link to={getLangPath("/slots", lang)} className="rr555-aviatorlux__link" data-discover="true">স্লটস</Link> সবখানেই স্মুথ, ধারাবাহিক পারফরম্যান্সে টিউন করা। আজই যোগ দিন এবং কয়েক মিনিটের মধ্যেই খুঁজে নিন একদম নতুন প্রিয়{" "}
                <Link to={getLangPath("/games", lang)} className="rr555-aviatorlux__link" data-discover="true">গেম</Link>।
              </div>
            </div>
          </div>
        </div>

        <div className="zHHBD-slotscats__cta">
          <a
            href="https://haruvest.com/W7DZsfpK"
            className="zHHBD-slotscats__btn"
            title="এখনই HHBD–এ যোগ দিন"
          >
            এখনই HHBD–এ যোগ দিন
          </a>
        </div>
      </div>
    </section>

    <section className="zHHBD-slotshowto">
      <div className="zHHBD-slotshowto__bg">
        <div className="zHHBD-slotshowto__spark zHHBD-slotshowto__spark--left"></div>
        <div className="zHHBD-slotshowto__spark zHHBD-slotshowto__spark--right"></div>
      </div>

      <div className="zHHBD-slotshowto__container">
        <header className="zHHBD-slotshowto__header">
          <h2 className="zHHBD-slotshowto__title">
            অনলাইন স্লটসের প্রধান ধরনগুলো চিনে নিন
          </h2>
        </header>

        <div className="zHHBD-slotshowto__content">
          <p className="zHHBD-slotshowto__desc">
            {/* এই সেকশনে আলাদা লিড টেক্সট নেই — তাই নিচের কার্ডগুলোর টেক্সটই মূল তথ্য হিসেবে ব্যবহার করা হচ্ছে */}
          </p>

          <div className="slots-body">
            <p className="zHHBD-slotshowto__desc">
              <strong>ক্লাসিক স্লটস</strong> — রেট্রো ফ্রুট মেশিনের নস্টালজিক আকর্ষণ ফিরে পান কিউরেটেড ক্লাসিক{" "}
              <Link to={getLangPath("/slots", lang)} className="rr555-aviatorlux__link" data-discover="true">স্লটস</Link>–এ। সহজে ধরার মতো এই{" "}
              <Link to={getLangPath("/games", lang)} className="rr555-aviatorlux__link" data-discover="true">গেমস</Link> থাকে পরিষ্কার ও তৃপ্তিদায়ক — নতুনদের জন্য পারফেক্ট, আর যারা সরল স্পিন পছন্দ করেন তাদের জন্য তো বটেই।
            </p>

            <p className="zHHBD-slotshowto__desc">
              <strong>ভিডিও স্লটস</strong> — আধুনিক ভিডিও{" "}
              <Link to={getLangPath("/slots", lang)} className="rr555-aviatorlux__link" data-discover="true">স্লটস</Link>–এ ডুব দিন সাহসী গল্প, সমৃদ্ধ ভিজুয়াল আর ডায়নামিক অডিওতে। ফিচার–প্যাকড এই{" "}
              <Link to={getLangPath("/games", lang)} className="rr555-aviatorlux__link" data-discover="true">গেমস</Link> দেয় ফ্রি স্পিন, ওয়াইল্ডস, মাল্টিপ্লায়ার ও স্তরে–স্তরে বোনাস রাউন্ড—বৈচিত্র্যের শেষ নেই।
            </p>

            <p className="zHHBD-slotshowto__desc">
              <strong>প্রগ্রেসিভ জ্যাকপট</strong> — প্রগ্রেসিভ{" "}
              <Link to={getLangPath("/slots", lang)} className="rr555-aviatorlux__link" data-discover="true">স্লটস</Link>–এ তাড়া করুন জীবন–বদলে–দেওয়া অঙ্ক। প্রতিটি বেট এক শেয়ার্ড প্রাইজপুলে যোগ হয়—একটা এপিক স্পিন সবটুকু জিতে নেওয়ার আগেই জ্যাকপট ফুলে ওঠে চোখ–ধাঁধানো সংখ্যায়।
            </p>

            <p className="zHHBD-slotshowto__desc">
              <strong>মেগাওয়েজ স্লটস</strong> — মেগাওয়েজ{" "}
              <Link to={getLangPath("/slots", lang)} className="rr555-aviatorlux__link" data-discover="true">স্লটস</Link>–এ আনলক করুন হাজার হাজার উইন–ওয়ে। প্রতিটি স্পিনে রিলের উচ্চতা বদলে যায়, সিম্বল গণনা রিমিক্স হয়—খেলাকে রাখে চঞ্চল, অনিশ্চিত, আর অসীমবার রিপ্লেয়েবল।
            </p>
          </div>
        </div>

        <div className="zHHBD-slotshowto__cta">
          <a
            href="https://haruvest.com/W7DZsfpK"
            className="zHHBD-slotshowto__btn"
            title="HHBD স্লটস খেলুন"
          >
            HHBD স্লটস খেলুন
          </a>
        </div>

        <a
          href="https://haruvest.com/W7DZsfpK"
          title="HHBD স্লটস – পছন্দের ৭৭৭ স্লট ট্রাই করুন ও জিতুন আসল BDT"
        >
          <img
            src={s3}
            alt="নিয়ন আভায় উচ্ছ্বসিত প্লেয়ার ৭৭৭ রিল উপভোগ করছেন — HHBD স্লটসের সিগনেচার ভাইব।"
            className="zHHBD-slotshowto__img-extra"
            title="HHBD স্লটস – পছন্দের ৭৭৭ স্লট ট্রাই করুন ও জিতুন আসল BDT"
          />
        </a>
      </div>
    </section>

    <section className="zHHBD-slotsnew">
      <div className="zHHBD-slotsnew__bg">
        <div className="zHHBD-slotsnew__starburst zHHBD-slotsnew__starburst--1"></div>
        <div className="zHHBD-slotsnew__starburst zHHBD-slotsnew__starburst--2"></div>
        <div className="zHHBD-slotsnew__lights"></div>
      </div>

      <div className="zHHBD-slotsnew__container">
        <div className="zHHBD-slotsnew__inner">
          <div className="zHHBD-slotsnew__left">
            <div className="zHHBD-slotsnew__visual">
              <a
                href="https://haruvest.com/W7DZsfpK"
                title="HHBD স্লটস – স্পিন করুন এবং বড় জ্যাকপটের খোঁজে নামুন"
              >
                <img
                  src={s4}
                  alt="ক্লাসিক ক্যাবিনেটে জ্বলজ্বলে ৭৭৭ ও চিপসের স্তূপ — HHBD স্লট জ্যাকপটের স্ন্যাপশট।"
                  className="zHHBD-slotsnew__img"
                  title="HHBD স্লটস – স্পিন করুন এবং বড় জ্যাকপটের খোঁজে নামুন"
                />
              </a>
              <div className="zHHBD-slotsnew__pulse"></div>
              <div className="zHHBD-slotsnew__badge">
                <i className="fa-solid fa-star"></i> NEW
              </div>
              <div className="zHHBD-slotsnew__jackpot-anim">
                <i className="fa-solid fa-coins"></i>
                <span>Jackpot!</span>
              </div>
            </div>
          </div>

          <div className="zHHBD-slotsnew__right">
            <header className="zHHBD-slotsnew__header">
              <h2 className="zHHBD-slotsnew__title">
                কেন HHBD–এ অনলাইন স্লটস খেলবেন?
              </h2>
            </header>

            <div className="zHHBD-slotsnew__cards-grid">
              <div className="zHHBD-slotsnew__card">
                <h3 className="zHHBD-slotsnew__card-title">
                  সঠিক{" "}
                  <Link to={getLangPath("/slots", lang)} className="rr555-aviatorlux__link" data-discover="true">স্লটস</Link> প্ল্যাটফর্ম বেছে নেওয়াই বদলে দিতে পারে সবকিছু।
                </h3>
                <p className="zHHBD-slotsnew__card-text">
                  HHBD প্লেয়ার–ফার্স্ট এনভায়রনমেন্ট বানিয়েছে—সন্তুষ্টি, লৌহদৃঢ় সিকিউরিটি ও যাচাইকৃত ফেয়ারনেসে নোঙর করা। এই ফোকাসই বাংলাদেশজুড়ে স্লট–ভক্তদের জন্য আমাদের করে তোলে আলাদা গন্তব্য।
                </p>
              </div>

              <div className="zHHBD-slotsnew__card">
                <h3 className="zHHBD-slotsnew__card-title">
                  সিকিউরিটি কোনো অপশন নয় — এটি অনড় শর্ত।
                </h3>
                <p className="zHHBD-slotsnew__card-text">
                  নিশ্চিন্তে স্পিন করুন। ব্যক্তিগত তথ্য থেকে পেমেন্ট—প্রতিটি ডিটেইল সুরক্ষায় আমরা অ্যাডভান্সড এনক্রিপশন ব্যবহার করি। আমরা লাইসেন্সপ্রাপ্ত, রেগুলেটেড, এবং কঠোর স্ট্যান্ডার্ড–সম্মত—আপনার অভিজ্ঞতা থাকে এন্ড–টু–এন্ড সেফ।
                </p>
              </div>

              <div className="zHHBD-slotsnew__card">
                <h3 className="zHHBD-slotsnew__card-title">
                  ফেয়ারনেস HHBD–এ আগে থেকেই বিল্ট–ইন।
                </h3>
                <p className="zHHBD-slotsnew__card-text">
                  সব স্লট{" "}
                  <Link to={getLangPath("/games", lang)} className="rr555-aviatorlux__link" data-discover="true">গেমস</Link> সার্টিফাইড RNG টেকে চলে—প্রতিটি স্পিনে নিরপেক্ষ ফল নিশ্চিত করতে। আমরা RTP তথ্যও স্বচ্ছ রাখি—আপনি ঠিক কী খেলছেন সবসময়ই স্পষ্ট থাকে।
                </p>
              </div>
            </div>

            <div className="zHHBD-slotsnew__cta">
              <a
                href="https://haruvest.com/W7DZsfpK"
                className="zHHBD-slotsnew__btn"
                title="HHBD স্লটস খেলুন"
              >
                HHBD স্লটস খেলুন
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  </>







      )}
    </>
  );
};

export default Slots;
